module.exports = __webpack_public_path__ + "img/HZ-A0223.e7ad6730.jpg";